import { empty } from 'dashboard-js/helpers'

export default {
    inserted: function(el, binding) {
        const enabled = empty(binding.value) ? true : binding.value

        if (enabled) {
            el.focus()
        }
    },
}
